import BarComparatorItem from './bar-item';
import CarIcons from 'components/icons/landing/car-icons';
import formatNumber from 'utils/format-number';
import PropTypes from 'prop-types';
import styles from 'styles/LandingComponents.module.scss';
import { useTranslations } from 'next-intl';

const RangeTableItem = ({ item, index }) => {
    const t = useTranslations('widgets.range-comparator');
    function getNumberSymbol (number) {
        const millions = 1000000;
        const thousand = 1000;
        if (number > millions) {
            return { value: number / millions, prefix: t('millions') };
        }
        if (number > thousand) {
            return { value: number / thousand, prefix: t('thousand') };
        }
        return { value: number, prefix: '' };
    }
    const carMin = getNumberSymbol(item.cpmn);
    const carMax = getNumberSymbol(item.cpmx);
    const prefix = index < 3 ? carMax.prefix : carMin.prefix;
    const iconsArr = ['small_car', 'medium_car', 'truck', 'lorry'];
    const max = index === 0 && formatNumber(carMax.value);
    const rangeStart = index !== 0 && carMin.value;
    const rangeEnd = index !== 3 && carMax.value;
    const minimumCoverage = item.ipmn;
    const maxTitle = `${t('max')} ${max} ${prefix}`;
    const rangeStartText = `${t('from')} ${rangeStart || ''}  ${
        rangeEnd ? `${t('to')} ${rangeEnd}` : ''
    } ${prefix}`;

    if (index > 3) {
        return null;
    }
    return (
        <div className={styles.comparator_range_wrapper}>
            <div>
                <div style={{ width: 80 }}>
                    <CarIcons icon={iconsArr[index]} />
                </div>
                {max && <p className={styles.range_title}>{maxTitle}</p>}
                {rangeStart && (
                    <p className={styles.range_title}>{rangeStartText}</p>
                )}
            </div>
            <BarComparatorItem
                width={index * 35 + 200}
                fullCoverage={item.ipmx}
                minimumCoverage={minimumCoverage}
            />
        </div>
    );
};

RangeTableItem.propTypes = {
    index: PropTypes.number.isRequired,
    item: PropTypes.object
};

export default RangeTableItem;
